<template>
  <div>
    <PageHeading
      :default-heading="pageHeader()"
      :edit-heading="pageHeader()"
    />
    <form
      novalidate="novalidate"
      @submit.prevent
    >
      <div class="pvd-container container-divider">
        <p>
          We can't open your account because we couldn't verify the information you entered.
          This may be due to a typo, or there could be a verification error if this is one of your first financial accounts.
        </p>
        <p>
          Please exit to try again, and confirm the information in every field is correct.
        </p>
      </div>
      <div
        class="pvd-container pvd-btn-row"
      >
        <div
          class="button-group"
        >
          <button
            class="pvd-btn btn-action"
            @click.prevent="handleUrlClick(modalUrl)"
          >
            Exit Application
          </button>
        </div>
        <div
          class="tertiary-link xsmall"
        >
          <a
            id="exit-overlay-modal-trigger"
            href="javascript:void(0)"
          >
            {{ modalExitVal }}
          </a>
        </div>
      </div>
      <ModalComponent
        :modal-header="modalHeader"
        :modal-body1="modalBody1"
        :modal-body2="modalBody2"
        :modal-footer="modalFooter"
        :modal-btn-url="modalUrl"
        :modal-btn-val="modalVal"
        id-val="exit-overlay-modal"
        @close-action="closeModal"
        @exitmodal-action="handleUrlClick"
      />

    </form>
  </div>
</template>

<script>
import ModalComponent from '../components/ModalComponent.vue';
import PageHeading from '../components/PageHeading.vue';
import utilityFunctions from '../mixins/utility';
import validationHelper from '../mixins/validationHelper';
import widgetHelper from '../mixins/widgetHelper';
import dataHelper from '../mixins/dataHelper';
import dataSanitize from '../mixins/dataSanitize';
import pageNavigationHelper from '../mixins/pageNavigationHelper';
import constants from '../mixins/constants';

export default {
  name: 'TrustIdentityVerificationFailure',
  components: {
    PageHeading,
    ModalComponent,
  },
  mixins: [
    utilityFunctions,
    validationHelper,
    widgetHelper,
    dataHelper,
    dataSanitize,
    pageNavigationHelper,
  ],
  mounted() {
    this.$store.commit('currentState/updateField', { path: 'stateName', value: 'trust-identity-verification-failure' });
  },
  computed: {
    modalHeader() {
      return this.pd_content.exit_overlay_modal_header || constants.MODAL_HEADER;
    },
    modalBody1() {
      return this.pd_content.exit_overlay_modal_body1 || constants.MODAL_BODY1;
    },
    modalBody2() {
      return this.pd_content.exit_overlay_modal_body2 || constants.MODAL_BODY2;
    },
    modalFooter() {
      return this.pd_content.exit_overlay_modal_footer || constants.MODAL_FOOTER;
    },
    modalExitVal() {
      return this.pd_content.exit_link ? this.pd_content.exit_link.value : constants.EXIT;
    },
    modalUrl() {
      let returnVal;
      if (this.$globalData?.tStoreResponse?.exitURL) {
        if (this.$globalData.tStoreResponse.exitURL.method === 'POST') {
          returnVal = { url: this.$globalData.tStoreResponse.exitURL.url, method: 'POST' };
        } else {
          returnVal = this.$globalData?.tStoreResponse?.exitURL?.url;
        }
      } else {
        returnVal = this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.all_accounts_url
          : constants.OVERLAY_EXIT_URL_LINK;
      }
      return returnVal;
    },
    modalVal() {
      return this.pd_content.overlay_exit_link ? this.pd_content.overlay_exit_link.value
        : constants.OVERLAY_EXIT_LINK_VAL;
    },
  },
  methods: {
    pageHeader() {
      const { currentUserIndex } = this.getInstanceData().currentState;
      const { formData } = this.getInstanceData();
      if (Object.hasOwn(this.getInstanceData().currentState, 'currentUserIndex') && Number.isInteger(this.getInstanceData().currentState.currentUserIndex)) {
        return 'We couldn\'t verify '.concat(`${formData.additionalUsers[currentUserIndex]?.firstName} ${formData.additionalUsers[currentUserIndex]?.lastName}`).concat('\'s identity');
      }
      return 'We couldn\'t verify '.concat(`${formData.primaryUser?.firstName} ${formData.primaryUser?.lastName}`).concat('\'s identity');
    },
    closeModal() {
      document
        .querySelector('#exit-overlay-modal')
        .setAttribute('active', 'false');
    },
    handleUrlClick(url) {
      this.track('overlay_exit_link', 'interaction');
      if (typeof url === 'object') {
        this.submitForm(this.createForm(url.url, this.$globalData?.tStoreResponse?.params || ''));
      } else {
        window.location.assign(url);
      }
    },
  },
};
</script>

<style scoped>
.top-margin-zero {
  margin-top: 0;
}
</style>
